import { Endpoint } from "shared/utils/endpoints";
import { getQueryforFilters, getQueryforFilters2 } from "shared/utils/helper";
import { HTTP_CLIENT } from "shared/utils/interceptor";

interface ListingProps {
  search: string;
  sortBy?: string;
  order?: string;
  pageNo: number;
  filter?: string;
}

const ActivateEvaluationsService = (payload: { id: string }) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.activateEvaluation.replace(":id", payload?.id)
  );
};

const DeActivateEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.deActivateEvaluation.replace(":id", payload?.id)
  );
};

const ActivateEvaluationVerionService = (payload: any) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.activateEvaluationVersion.replace(":id", payload?.id)
  );
};

const DeleteEvaluationVersiontService = (payload: any) => {
  return HTTP_CLIENT.delete(
    Endpoint.evaluations.deleteEvaluationVersion.replace(":id", payload?.id)
  );
};

const GetCurrentEvaluationVersionDetailService = (payload: { id: string }) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getCurrentVersionDetails.replace(":id", payload?.id)
  );
};

const UpdateEvaluationService = (payload: any, id: string) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.updateEvaluation.replace(":id", id),
    payload
  );
};

const GetPendingEvaluationsService = (payload: ListingProps) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.pendingEvaluations.get +
      `?search=${payload.search}&pageNo=${payload.pageNo}${
        payload?.sortBy && payload?.order
          ? `&sortBy=${payload.sortBy}&order=${payload.order}`
          : ""
      }`
  );
};

const GetOrgainzationPendingEvaluationsService = (
  payload: ListingProps,
  id: string
) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.pendingEvaluations.getOrgList.replace(":id", id) +
      `?search=${payload.search}&pageNo=${payload.pageNo}${
        payload?.sortBy && payload?.order
          ? `&sortBy=${payload.sortBy}&order=${payload.order}`
          : ""
      }`
  );
};

const GetSingleEvaluationVersionsService = (payload: {
  search: string;
  id: string;
  filter?: any;
}) => {
  let query = `?search=${payload?.search}`;
  if (payload.filter) {
    query += getQueryforFilters(payload);
  }
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getSingleEvaluation.replace(":id", payload.id) + query
  );
};

const GetOrganizationEvaluationsService = (
  payload: ListingProps,
  id: string
) => {
  let query = `?search=${payload?.search}&pageNo=${payload.pageNo}${
    payload?.sortBy && payload?.order
      ? `&sortBy=${payload.sortBy}&order=${payload.order}`
      : ""
  }`;
  if (payload.filter) {
    query += getQueryforFilters2(payload);
  }
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getOrganizationEvaluations.replace(":id", id) + query
  );
};

const CompletePendingEvaluationService = (payload: any, id: string) => {
  return HTTP_CLIENT.post(
    Endpoint.evaluations.pendingEvaluations.add.replace(":id", id),
    payload
  );
};

const GetSinglePendingEvalutionService = (id: string) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.pendingEvaluations.getSingle.replace(":id", id)
  );
};

const AddDraftEvaluationsService = (payload: any, id: any) => {
  return HTTP_CLIENT.post(
    Endpoint.evaluations.addDraftEvaluation.replace(":id", id),
    payload
  );
};

const DownloadEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.evaluations.download, payload);
};

const DownloadAllEvaluationsService = (payload: any, id: string) => {
  return HTTP_CLIENT.post(
    Endpoint.evaluations.downloadAll.replace(":id", id),
    payload
  );
};

export {
  GetSingleEvaluationVersionsService,
  GetOrganizationEvaluationsService,
  CompletePendingEvaluationService,
  GetPendingEvaluationsService,
  ActivateEvaluationsService,
  DeActivateEvaluationsService,
  ActivateEvaluationVerionService,
  DeleteEvaluationVersiontService,
  GetCurrentEvaluationVersionDetailService,
  UpdateEvaluationService,
  GetSinglePendingEvalutionService,
  AddDraftEvaluationsService,
  GetOrgainzationPendingEvaluationsService,
  DownloadEvaluationsService,
  DownloadAllEvaluationsService,
};
